import { render, staticRenderFns } from "./CustomAttributeDropDown.vue?vue&type=template&id=119d0e32&scoped=true&"
import script from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeDropDown.vue?vue&type=style&index=0&id=119d0e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d0e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119d0e32')) {
      api.createRecord('119d0e32', component.options)
    } else {
      api.reload('119d0e32', component.options)
    }
    module.hot.accept("./CustomAttributeDropDown.vue?vue&type=template&id=119d0e32&scoped=true&", function () {
      api.rerender('119d0e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/customAttributes/CustomAttributeDropDown.vue"
export default component.exports